import { format } from "date-fns";
import { Zap } from "lucide-react";
import { cn } from "@/lib/utils";

// Dumb presenter for one API message ({body, sender_id, created_at, ...}).
// Ownership is decided by the window (sender_id vs current user) and passed
// down as `mine` so this component never needs auth context.
export default function ChatBubble({ message, mine = false }) {
  if (!message) return null;

  if (message.system) {
    return (
      <div className="my-3 flex justify-center">
        <span className="rounded-full border border-night-line bg-night-surface px-3.5 py-1.5 text-xs text-night-sub">
          {message.body}
        </span>
      </div>
    );
  }

  return (
    <div className={cn("flex", mine ? "justify-end" : "justify-start")}>
      <div
        className={cn(
          "max-w-[78%] rounded-2xl px-4 py-2.5 text-sm",
          mine
            ? "rounded-br-none bg-brand-primary text-white"
            : "rounded-bl-none bg-night-surface text-night-text"
        )}
      >
        {message.automated && (
          <span
            className={cn(
              "mb-1 inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold",
              mine ? "bg-brand-ink/10 text-brand-ink" : "bg-night-tint text-night-sub"
            )}
          >
            <Zap size={9} /> Auto reply
          </span>
        )}
        <p className="whitespace-pre-wrap leading-relaxed">{message.body}</p>
        {message.created_at ? (
          <p className={cn("mt-1 text-[10px]", mine ? "text-brand-ink/70" : "text-night-sub")}>
            {format(new Date(message.created_at), "h:mm a")}
          </p>
        ) : null}
      </div>
    </div>
  );
}
